import { styled } from '@mui/material';

import { Typography, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { usePricing } from '@app-velocity/config';

import { Plan } from '../Plan';

const StyledPrice = styled(Typography)(({ theme }) => ({
  fontSize: 40,
  fontWeight: 700,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  small: {
    fontSize: 13,
    fontWeight: 300,
  },
}));

export const EnterprisePlan = () => {
  const { t } = useI18n();
  const { getPlanPrice } = usePricing();

  return (
    <Plan
      highlighted={false}
      name="payments:plans.enterprise.title"
      price={<StyledPrice>{getPlanPrice('enterprise')}</StyledPrice>}
      description={[
        'payments:plans.enterprise.description.a',
        'payments:plans.enterprise.description.b',
        'payments:plans.enterprise.description.c',
        'payments:plans.enterprise.description.d',
        'payments:plans.enterprise.description.e',
        'payments:plans.enterprise.description.f',
        'payments:plans.enterprise.description.g',
        'payments:plans.enterprise.description.h',
        'payments:plans.enterprise.description.i',
      ]}
      action={
        <Button
          variant="contained"
          color="secondary"
          component="a"
          href="mailto:contact@appvelocity.io"
        >
          {t('payments:plans.enterprise.contact_sales')}
        </Button>
      }
    />
  );
};
